import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../api";
import { PAYWALL_CONFIG } from "src/paywallConfig";
import { getPaywallType } from "src/appConfig";

const initialState = {
  plans: [],
  activePlan: null,
  activeUpsalePlan: null,
  isLoading: false,
};

export const getPlansThunk = createAsyncThunk(
  "plans/getPlans",
  async () => {
    try {
      const res = await axiosInstance.get("/subscription-plans");
      const { items } = res.data;
      const paywal = getPaywallType();
      const paywalConfig = PAYWALL_CONFIG[paywal] || PAYWALL_CONFIG.QUIZ_PAYWALL_V2

      const enrichPlan = (plan) => {
        const matched = items.find((i) => i.reference === plan.reference);
        const enriched = matched
          ? {
              ...matched,
              ...plan,
            }
          : plan;

        if (plan.retentionReference) {
          const retention = items.find(
            (i) => i.reference === plan.retentionReference
          );
          if (retention) {
            enriched.retention = retention;
          }
        }

        if (Array.isArray(plan.upsellsTo)) {
          enriched.upsellsTo = plan.upsellsTo.map((group) =>
            Array.isArray(group) ? group.map(enrichPlan) : enrichPlan(group)
          );
        }

        return enriched;
      };

      const plans = paywalConfig.map(enrichPlan);

      return plans;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
    setActivePlan(state, action) {
      state.activePlan = action.payload;
    },
    setActiveUpsalePlan(state, action) {
      state.activeUpsalePlan = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlansThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlansThunk.fulfilled, (state, { payload }) => {
        if (payload) {
          state.plans = payload;
          state.activePlan = payload.find(
            (item) => item.uiDisplayOptions.focused
          );
        }
        state.isLoading = false;
      });
  },
});

export const reducer = plansSlice.reducer;

export const { reset, setActivePlan, setActiveUpsalePlan } = plansSlice.actions;
